import React from 'react';

const LoadingSpinner = ({ label = 'Cargando...', inline = false }) => {
  return (
    <div className={inline ? 'loading-spinner-inline' : 'loading-spinner-screen'} role="status" aria-live="polite">
      <div className="loading-spinner" aria-hidden="true" />
      <span className="loading-spinner-text">{label}</span>
    </div>
  );
};

export default LoadingSpinner;